import { useEffect, useState } from 'react'
import { KENO_DEFAULT_BET_LIMITS } from '@nexbit/types'
import { api } from '@/lib/api'

/** "CHOOSE YOUR BET LIMIT" — the reference entry screen before the board. */
export function BetLimitPage({ onChoose }: { onChoose: (tier: number) => void }) {
  const [limits, setLimits] = useState<{ min: number; max: number }[] | null>(null)

  useEffect(() => {
    api.tables()
      .then((r) => setLimits(r.tables[0]?.betLimits ?? KENO_DEFAULT_BET_LIMITS))
      .catch(() => setLimits(KENO_DEFAULT_BET_LIMITS))
  }, [])

  return (
    <>
      <div className="betlimitpop">
        <h2>CHOOSE YOUR BET LIMIT</h2>
        {(limits ?? []).map((l, i) => (
          <a key={i} href="/" onClick={(e) => { e.preventDefault(); onChoose(i) }}>
            <div>
              {'\n        Min '}<span>{l.min}</span>{' \n        Max '}<span>{l.max}</span>
            </div>
          </a>
        ))}
      </div>
      <div style={{ textAlign: 'right' }}>Version 2025.10.288.1</div>
    </>
  )
}
